// extracted by mini-css-extract-plugin
export default {"cls1":"VeloIconButton-StyledIconButton_cls1__iTbmB","cls2":"VeloIconButton-StyledIconButton_cls2__0970q VeloIconButton-StyledIconButton_cls1__iTbmB"};